<div class="signature-modal-container">
    <!-- Header -->
    <div class="modal-header">
        <h5 class="modal-title">
            <i class="fa-solid fa-file-signature me-2"></i>
            Selectare Zonă - Semnătură Electronică
        </h5>
        <button type="button" class="btn-close" (click)="cancel()"></button>
    </div>

    <!-- Body -->
    <div class="modal-body">
        <!-- Loading State (overlay) -->
        <div *ngIf="isLoading" class="loading-overlay">
            <div class="text-center">
                <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
                <p class="mt-3 text-muted">Se incarca documentul...</p>
            </div>
        </div>

        <!-- Error State -->
        <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
            <i class="fa-solid fa-triangle-exclamation me-2"></i>
            {{ errorMessage }}
        </div>

        <!-- Main Content - always in DOM, hidden when loading/error -->
        <div [hidden]="isLoading || errorMessage" class="pdf-viewer-content">
            <!-- Selection Mode Toggle -->
            <div class="selection-mode-toggle mb-3">
                <mat-button-toggle-group [(ngModel)]="selectionMode" (change)="onModeChange()">
                    <mat-button-toggle value="click">
                        <mat-icon>touch_app</mat-icon>
                        <span class="ms-1">Click pentru Plasare</span>
                    </mat-button-toggle>
                    <mat-button-toggle value="draw">
                        <mat-icon>crop_free</mat-icon>
                        <span class="ms-1">Desenare Manuală</span>
                    </mat-button-toggle>
                </mat-button-toggle-group>
                <small class="text-muted ms-3" *ngIf="selectionMode === 'click'">
                    Dimensiuni: {{ defaultWidth }} x {{ defaultHeight }} pt
                </small>
            </div>

            <!-- Instructions based on mode -->
            <div class="alert alert-info mb-3">
                <i class="fa-solid fa-info-circle me-2"></i>
                <strong>Instrucțiuni:</strong>
                <span *ngIf="selectionMode === 'click'">
                    Click pe document pentru a plasa semnătura. După plasare, puteți trage zona pentru a o muta.
                </span>
                <span *ngIf="selectionMode === 'draw'">
                    Faceți click și trageți pe document pentru a desena zona unde doriți să aplicați semnătura electronică.
                </span>
            </div>

            <!-- Warning Message -->
            <div *ngIf="warningMessage" class="alert alert-warning mb-3">
                <i class="fa-solid fa-exclamation-triangle me-2"></i>
                {{ warningMessage }}
            </div>

            <!-- PDF Controls -->
            <div class="pdf-controls d-flex justify-content-between align-items-center mb-3">
                <div class="page-navigation">
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                        [disabled]="currentPageNumber <= 1"
                        (click)="previousPage()">
                        <i class="fa-solid fa-chevron-left"></i>
                    </button>
                    <span class="mx-3">
                        Pagina {{ currentPageNumber }} / {{ totalPages }}
                    </span>
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                        [disabled]="currentPageNumber >= totalPages"
                        (click)="nextPage()">
                        <i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>
                <div class="zoom-controls">
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                        [disabled]="currentScale <= 0.5"
                        (click)="zoomOut()">
                        <i class="fa-solid fa-minus"></i>
                    </button>
                    <span class="mx-2">{{ (currentScale * 100) | number:'1.0-0' }}%</span>
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                        [disabled]="currentScale >= 3.0"
                        (click)="zoomIn()">
                        <i class="fa-solid fa-plus"></i>
                    </button>
                </div>
            </div>

            <!-- PDF Viewer Container -->
            <div class="viewer-container">
                <div class="canvas-wrapper">
                    <!-- PDF Canvas -->
                    <canvas #pdfCanvas class="pdf-canvas"></canvas>
                    <!-- Overlay Canvas for Selection -->
                    <canvas #overlayCanvas class="overlay-canvas"
                        [style.cursor]="selection.isDrawing ? 'grabbing' : 'crosshair'">
                    </canvas>
                </div>
            </div>

            <!-- Selected Area Information -->
            <div *ngIf="selectedArea" class="selected-area-info mt-3">
                <div class="card border-success">
                    <div class="card-body">
                        <h6 class="card-title text-success mb-3">
                            <i class="fa-solid fa-check-circle me-2"></i>
                            Zonă Selectată pentru Semnătură
                        </h6>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="text-muted small">Pagina:</div>
                                <div class="fw-bold">{{ selectedArea.pageNumber }}</div>
                            </div>
                            <div class="col-md-3">
                                <div class="text-muted small">Pozitie (PDF):</div>
                                <div class="fw-bold">
                                    X: {{ selectedArea.x }}, Y: {{ selectedArea.y }}
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="text-muted small">Dimensiuni (PDF):</div>
                                <div class="fw-bold">
                                    {{ selectedArea.width }} x {{ selectedArea.height }} pt
                                </div>
                            </div>
                            <div class="col-md-3 d-flex align-items-end">
                                <button type="button" class="btn btn-sm btn-outline-secondary"
                                    (click)="clearSelection()">
                                    <i class="fa-solid fa-times me-1"></i>
                                    Sterge Selectia
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="cancel()">
            <i class="fa-solid fa-times me-1"></i>
            Anuleaza
        </button>
        <button type="button" class="btn btn-primary"
            [disabled]="!selectedArea"
            (click)="applySignature()">
            <i class="fa-solid fa-check me-1"></i>
            Aplică Semnătura
        </button>
    </div>
</div>
